<template>
    <td v-hidden="'xs,sm,md'" class="align-top text-center">
        <!-- eslint-disable-next-line vue/require-v-for-key -->
        <div v-for="pkg in partResult.Packaging">
            <span>{{ pkg.PackageType }}</span>
            <span v-if="pkg.MinimumOrderQuantity">({{ pkg.MinimumOrderQuantity.toLocaleString() }})</span>
        </div>
    </td>
</template>

<script>
export default {
    props: { partResult: { type: Object, required: true } },
};
</script>
